export default __webpack_public_path__ + "static/media/invision -logo.3a925ab6.svg";